import { useState } from "react";
import { Loader2 } from "lucide-react";

export function formatErr(detail) {
  if (!detail) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export function useSubmitState(action) {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await action();
    } catch (err) {
      setError(formatErr(err.response?.data?.detail ?? err.message));
    } finally {
      setLoading(false);
    }
  };
  return { error, loading, submit };
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function AuthLayout({ title, testId, footer, children }) {
  return (
    <div className="max-w-[480px] mx-auto px-4 md:px-8 mt-16" data-testid={testId}>
      <h1 className="font-display text-4xl uppercase border-b-2 border-black pb-2">/ {title}</h1>
      {children}
      <div className="font-mono-data text-xs uppercase mt-4 text-center">{footer}</div>
    </div>
  );
}

export function AuthField({ label, testId, ...inputProps }) {
  return (
    <label className="block">
      <span className="font-mono-data text-xs uppercase font-bold block mb-1">{label}</span>
      <input data-testid={testId} required {...inputProps} className="w-full border-2 border-black px-3 py-2 font-mono-data rounded-none focus:outline-none focus:ring-2 focus:ring-[#0000EE]" />
    </label>
  );
}

export function AuthError({ testId, message }) {
  if (!message) return null;
  return <div data-testid={testId} className="border-2 border-[#FF0000] bg-red-50 p-2 font-mono-data text-xs uppercase text-[#FF0000]">{message}</div>;
}

export function Notice({ testId, title, children }) {
  return (
    <div data-testid={testId} className="border-2 border-[#008800] bg-green-50 p-4 font-mono-data text-xs uppercase text-[#005500]">
      {title && <div className="font-bold mb-1">{title}</div>}
      <div>{children}</div>
    </div>
  );
}

export function SubmitButton({ testId, loading, children }) {
  return (
    <button data-testid={testId} type="submit" disabled={loading} className="w-full bg-black text-white px-4 py-3 border-2 border-black font-mono-data uppercase text-sm hover:bg-[#0000EE] hover:border-[#0000EE] disabled:opacity-50 flex items-center justify-center gap-2">
      {loading && <Loader2 className="animate-spin" size={14} />} {children}
    </button>
  );
}

export function GoogleButton({ testId }) {
  return (
    <>
      <div className="relative flex items-center py-1">
        <div className="flex-grow border-t border-black"></div>
        <span className="mx-3 font-mono-data text-xs uppercase text-gray-600">or</span>
        <div className="flex-grow border-t border-black"></div>
      </div>
      <button data-testid={testId} type="button" onClick={startGoogleLogin} className="w-full bg-white text-black px-4 py-3 border-2 border-black font-mono-data uppercase text-sm hover:bg-yellow-100">
        Continue with Google →
      </button>
    </>
  );
}
